import { apiClient } from "@api/apiClient";
import {
  GetArticleInfoResponse,
  ReviewRequiredInformation,
  ReviewRequiredInformationList,
} from "@api/articleInfo/articleInfo.interface";

import type {
  PutArticleInfoArg,
  PutArticleInfoResponse,
} from "@interface/articleInfo.interface";

export const API_ENDPOINT = {
  get: "/des/draft-article/info",
  update: "/des/draft-article/update",
  reviewRequiredUpdate: "/des/draft-article/review-required",
  updateNewInfoReviewRequired: "/des/draft-article/v2/review-required",
};

export const articleInfoApis = {
  get: async (draftArticleId: number) => {
    const { data } = await apiClient.get<GetArticleInfoResponse>(
      `${API_ENDPOINT.get}/${draftArticleId}`,
    );

    return data;
  },
  put: async (articleInfo: PutArticleInfoArg) => {
    const { data } = await apiClient.put<PutArticleInfoResponse>(
      API_ENDPOINT.update,
      articleInfo,
    );

    return data;
  },
  reviewRequiredPut: async (
    pressId: number,
    { isReviewRequired, reviewId }: ReviewRequiredInformation,
  ) => {
    const url = `${API_ENDPOINT.reviewRequiredUpdate}/?id=${pressId}`;
    const { data } = await apiClient.put(url, {
      isReviewRequired,
      reviewId,
    });

    return data;
  },
  updateNewInfoReviewRequired: async (
    pressId: number,
    reviewRequiredInformationList: ReviewRequiredInformationList,
  ) => {
    const url = `${API_ENDPOINT.updateNewInfoReviewRequired}/?id=${pressId}`;
    const { data } = await apiClient.post(url, {
      reviewInformationList: reviewRequiredInformationList,
    });

    return data;
  },
};
